import React from 'react';
import Title from '../Title/Title';

import * as S from './ContactDetails.styles';

const ContactDetails = ({currentLang}) => {
  return (
    <S.Container>
      <Title title={currentLang === 'arabic' ? 'دبي' : 'Dubai'} />
      {currentLang === 'arabic' ? (
        <h3>
          <span>
            شركة ميكمايتريب للسفريات والسياحة ذ.م.م تعمل بموجب القوانين المعمول بها في إمارة دبي،
            حيث يقع مقرها في
          </span>
        </h3>
      ) : (
        <h3>
          <span>MakeMyTrip Travel & Tourism LLC,</span> a company incorporated under the laws of
          Dubai having its registered office at
        </h3>
      )}
      <S.Content>
        <S.ContentLeft>
          {currentLang === 'arabic' ? (
            <p>
              مكتب رقم 105 -,مكاتب في بوابة ابن بطوطة - جبل علي الأول - دبي، الإمارات العربية
              المتحدة
            </p>
          ) : (
            <p>
              Office No. 105, the Offices at Ibn Battuta Gate, Jebal Ali First, Dubai, United Arab
              Emirates
            </p>
          )}
        </S.ContentLeft>
        {/* {<S.ContentRight>
        <h4>
          {currentLang === 'arabic'
            ? 'خط المساعدات (الإمارات العربية المتحدة)'
            : 'HELP LINE (UAE):'}
        </h4>
        <p>
          <span>
            {currentLang === 'arabic'
              ? '+971 600521404, +971 8000180004'
              : '+971 600521404, +971 8000180004'}{' '}
            -
          </span>{' '}
          {currentLang === 'arabic'
            ? `
يظلّ جميع مكاتب الإمارات مفتوحةً بين (9.00 صباحاً`
            : 'All UAE operators (9:00 AM to 9:00 PM GST'}
        </p>
      </S.ContentRight>} */}
      </S.Content>
    </S.Container>
  );
};

export default ContactDetails;
